import { getRootUrl } from '@utils/urlHelpers.util';
import { CloudImageRowProps } from '@components/CloudImageRow';

export const SLIDE_SPEED = 3;

export const SECTION_ID = 'BabyRegistryShopRegistrySection';

export const BRANDS_ELEMENT_ID = 'shop-brands-marquee';

export const DEPARTMENTS_ELEMENT_ID = 'departments-carousel';

export const VENDOR_IMAGES: CloudImageRowProps = [
  // To Do - W'll add them back in January or February.
  // {
  //   title: 'Uppababy',
  //   link: getRootUrl('/shop/baby/brand/uppababy'),
  //   image: {
  //     url: 'baby-registry/logos/uppababy.png',
  //   },
  //   sm: {
  //     width: 243,
  //     height: 40,
  //   },
  //   belowSm: {
  //     width: 152,
  //     height: 25,
  //   },
  // },
  // {
  //   title: 'Doona',
  //   link: getRootUrl('/shop/baby/brand/doona'),
  //   image: {
  //     url: 'baby-registry/logos/doona.svg',
  //   },
  //   sm: {
  //     width: 164,
  //     height: 45,
  //   },
  //   belowSm: {
  //     width: 91,
  //     height: 25,
  //   },
  // },
  // {
  //   title: 'Stokke',
  //   link: getRootUrl('/shop/baby/brand/stokke'),
  //   image: {
  //     url: 'baby-registry/logos/stokke.png',
  //   },
  //   sm: {
  //     width: 90,
  //     height: 80,
  //   },
  //   belowSm: {
  //     width: 45,
  //     height: 40,
  //   },
  // },
  {
    title: 'Maxi-cosi',
    link: getRootUrl('/shop/baby/brand/maxi-cosi'),
    image: {
      url: 'baby-registry/logos/maxi-cosi-v2.svg',
    },
    sm: {
      width: 204,
      height: 45,
    },
    belowSm: {
      width: 111,
      height: 25,
    },
  },
  {
    title: 'Halo',
    link: getRootUrl('/shop/baby/brand/halo'),
    image: {
      url: 'baby-registry/logos/halo-v2.png',
    },
    sm: {
      width: 125,
      height: 50,
    },
    belowSm: {
      width: 62.75,
      height: 25,
    },
  },
  {
    title: 'Nanit',
    link: getRootUrl('/shop/baby/brand/nanit'),
    image: {
      url: 'baby-registry/logos/nanit-v2.png',
    },
    sm: {
      width: 130,
      height: 45,
    },
    belowSm: {
      width: 72.5,
      height: 25,
    },
  },
  {
    title: '4moms',
    link: getRootUrl('/shop/baby/brand/4moms'),
    image: {
      url: 'baby-registry/logos/4moms-v2.svg',
    },
    sm: {
      width: 168,
      height: 45,
    },
    belowSm: {
      width: 93,
      height: 25,
    },
  },
  {
    title: 'Newton',
    link: getRootUrl('/shop/baby/brand/newton'),
    image: {
      url: 'baby-registry/logos/newton-baby-v2.svg',
    },
    sm: {
      width: 229,
      height: 40,
    },
    belowSm: {
      width: 143.28,
      height: 25,
    },
  },
  {
    title: 'Oxo',
    link: getRootUrl('/shop/baby/brand/oxo'),
    image: {
      url: 'baby-registry/logos/oxo.svg',
    },
    sm: {
      width: 136,
      height: 45,
    },
    belowSm: {
      width: 75.75,
      height: 25,
    },
  },
  {
    title: 'Frida',
    link: getRootUrl('/shop/baby/brand/frida'),
    image: {
      url: 'baby-registry/logos/frida.svg',
    },
    sm: {
      width: 113,
      height: 45,
    },
    belowSm: {
      width: 62.88,
      height: 25,
    },
  },
  {
    title: 'Munchkin',
    link: getRootUrl('/shop/baby/brand/munchkin'),
    image: {
      url: 'baby-registry/logos/munchkin.svg',
    },
    sm: {
      width: 185,
      height: 45,
    },
    belowSm: {
      width: 103,
      height: 25,
    },
  },
  {
    title: 'Skiphop',
    link: getRootUrl('/shop/baby/brand/skip-hop'),
    image: {
      url: 'baby-registry/logos/skiphop.svg',
    },
    sm: {
      width: 170,
      height: 40,
    },
    belowSm: {
      width: 106.25,
      height: 25,
    },
  },
  {
    title: 'Drbrown',
    link: getRootUrl('/shop/baby/brand/drbrown'),
    image: {
      url: 'baby-registry/logos/drbrown.svg',
    },
    sm: {
      width: 152,
      height: 45,
    },
    belowSm: {
      width: 84.67,
      height: 25,
    },
  },
];
